import { Save } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Api from "../../../api2";
import { userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { FormNhap } from "./form";

const RoutesCauHinhHienThiSanPham = [
  {
    path: "",
    main: () => <CauHinhHienThiSanPham />
  }
];
export default RoutesCauHinhHienThiSanPham;

function CauHinhHienThiSanPham() {
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const formRef = useRef(null);
  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (!data) {
      setIsLoading(true);
      new Api()
        .GetCauHinhHienThi({})
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = {
    fieldChucNangs: data
  };

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertCauHinhHienThi({
        token: user.access_token,
        data: formRef?.current?.values?.fieldChucNangs
      })
      .then(res => {
        if (!res || res.code !== 200) {
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: res?.data });
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Quản trị hệ thống" },
            { name: "Cấu hình hiển thị thông tin truy xuất" }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          // justifyContent: "flex-end",
          marginBottom: 15,
          marginLeft: 25
        }}
      >
        <MyButton
          onClick={handleSave}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
